import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/core/services/alert.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { FunnelService } from 'src/app/pages/new-service/services/funnel.service';

@Component({
    selector: 'app-modal-rename-file-link',
    templateUrl: './modal-rename-file-link.component.html',
    styleUrls: ['./modal-rename-file-link.component.scss'],
})


export class ModalRenameFileLinkComponent implements OnInit {
    newName: string = '';
    textAlert = '';
    showErrorAlert = false;
    constructor(
        private dialogRef: MatDialogRef<ModalRenameFileLinkComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { pdfId: string; name: number; },
        private funnelService: FunnelService,
        private alertService: AlertService,
        private loader: LoaderService,
        private translationService: TranslateService
    ) {
        this.newName = this.data.name.toString();
    }

    ngOnInit() {

    }

    rename(): void {
        this.loader.show();
        this.funnelService.changeFileOrLinkName(this.data.pdfId, this.newName).subscribe((res) => {
            this.dialogRef.close(this.newName);
            this.loader.hide();
        },
            (error) => {
                this.textAlert = this.translationService.instant('error_renaming_link');
                this.showErrorAlert = true;
                this.alertService.setShowAlert(true);
                this.loader.hide();
                this.dialogRef.close(null);
            });
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onErrorAlertClosed(): void {
        this.showErrorAlert = false;
        this.alertService.setShowAlert(false);
    }
}